import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { Button, Select } from '../../../components';

export default class ProviderFilterModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		userShown: PropTypes.number,
		onOk: PropTypes.func.isRequired,
		onCancel: PropTypes.func.isRequired,
		providers: PropTypes.array.isRequired
	}

	static defaultProps = {
		isOpen: false
	}

	state = {
		userIdShown: -1
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({ userIdShown: nextProps.userShown });
	}

	handleProviderChange = ({ target }) => {
		const userIdShown = parseInt(target.value, 10);
		this.setState({ userIdShown });
	}

	handleOk = () => {
		this.props.onOk(this.state.userIdShown);
	}

	render() {
		const { isOpen, onCancel, providers } = this.props;
		const { userIdShown } = this.state;

		const providerOptions = providers.map(provider => ({
			value: provider.providerId,
			label: `${provider.name_first} ${provider.name_last}, ${provider.credentials}${provider.virtual_provider ? `, ${provider.virtual_providing_practice_name} *` : ''}`
		}));
		providerOptions.unshift({ value: -1, label: 'All Providers' });

		return (
			<Modal isOpen={isOpen} contentLabel="Schedule Provider Filter" className="modal-dialog modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onCancel}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								Show Schedule for
							</h3>
						</div>
					</div>
					<div className="modal-body form">
						<div className="form-group">
							<label>Select Provider(s)</label>
							<Select
								options={providerOptions}
								selectedValue={userIdShown}
								onChange={this.handleProviderChange}
							/>
							<span className="help-block">* Embedded Provider</span>
						</div>
					</div>
					<div className="modal-footer">
						<div className="pull-right">
							<Button
								title="Cancel"
								large
								onClick={onCancel}
							/>
							<Button
								title="OK"
								onClick={this.handleOk}
								large
								primary
								className="ml"
							/>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
